export { appConfig as default, metadataFactory } from './appConfig'
export * from './appConfigContext'
export * from './updateAppConfigDynamically'
